// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'
import { UpdatedLabeledInputWrapper } from 'components/Form/updated/UpdatedLabeledInput/styles'

export const UpdatedMultiSelectAsyncWrapper = styled(UpdatedLabeledInputWrapper)`
  grid-template-rows: repeat(2, auto) 1fr;

  > .input {
    border: 0;
    height: auto;
    padding: 0;
    overflow: visible;

    &.react-select--is-disabled {
      cursor: not-allowed;
      pointer-events: all;

      > .react-select__control {
        cursor: not-allowed;
        pointer-events: none;
      }
    }

    > .react-select__control {
      // matches UpdatedLabeledInput border-radius.
      border-radius: .15em;
      border-width: 0;
      box-shadow: inset 0 0 0 1px #000;
    }
  }
`
